import * as React from "react";
import type { SVGProps } from "react";
const SvgDiscover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#discover_svg__a)">
      <path
        fill="#f4f4f4"
        fillRule="evenodd"
        d="M20.5 5.5H3c-.5 0-1 .5-1 1v10Q2 18 3.5 18h17q1.5 0 1.5-1.5V7q0-1.5-1.5-1.5"
        clipRule="evenodd"
      />
      <path
        fill="#d97b16"
        fillRule="evenodd"
        d="M8.193 18H20.5q1.5 0 1.5-1.5v-5.946S19.02 15.8 8.193 18"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M3.767 8.486h.941q.237 0 .456.072t.388.221.27.373.101.528q0 .307-.116.532-.117.224-.3.371a1.3 1.3 0 0 1-.409.22q-.224.072-.44.072h-.891zm.742 2.004q.199 0 .377-.045a.9.9 0 0 0 .308-.142.7.7 0 0 0 .208-.25.8.8 0 0 0 .076-.373.9.9 0 0 0-.068-.371.65.65 0 0 0-.187-.251.8.8 0 0 0-.283-.142 1.3 1.3 0 0 0-.36-.046h-.388v1.62zm1.81-2.005h.424v2.39h-.425zM8.437 9a.4.4 0 0 0-.18-.144.63.63 0 0 0-.382-.029.4.4 0 0 0-.125.054.3.3 0 0 0-.09.097.3.3 0 0 0-.033.14q0 .12.084.185a.8.8 0 0 0 .21.112q.124.047.273.09.149.044.273.122t.21.206q.084.13.084.341a.75.75 0 0 1-.071.336.7.7 0 0 1-.19.238.8.8 0 0 1-.28.142 1.25 1.25 0 0 1-.763-.027.8.8 0 0 1-.353-.25l.32-.31q.078.118.204.183a.57.57 0 0 0 .417.046.5.5 0 0 0 .135-.061.3.3 0 0 0 .098-.103.3.3 0 0 0 .037-.143.25.25 0 0 0-.084-.203.8.8 0 0 0-.21-.12 3 3 0 0 0-.273-.092q-.149-.045-.273-.12a.7.7 0 0 1-.21-.203.6.6 0 0 1-.084-.339.64.64 0 0 1 .275-.545.9.9 0 0 1 .282-.133 1.2 1.2 0 0 1 .69.013.85.85 0 0 1 .32.19zm2.406.047a.7.7 0 0 0-.255-.19.7.7 0 0 0-.248-.046.8.8 0 0 0-.336.065.8.8 0 0 0-.258.183.8.8 0 0 0-.167.271 1.03 1.03 0 0 0 0 .689q.06.162.167.28a.78.78 0 0 0 .594.253q.145 0 .282-.07a.8.8 0 0 0 .255-.22l.35.25a.96.96 0 0 1-.394.324 1.2 1.2 0 0 1-.496.1q-.277 0-.508-.089a1.2 1.2 0 0 1-.398-.253 1.2 1.2 0 0 1-.262-.393 1.3 1.3 0 0 1-.094-.51q0-.286.094-.521t.262-.4.398-.255.508-.09q.243 0 .45.087.209.086.387.292zm3.206-.56h.49l.651 1.805.672-1.806h.459l-.966 2.39h-.367zm2.528 0h1.583v.384h-1.158v.588H18.1v.384h-1.097v.648h1.219v.385h-1.644zm2.062 0h.83q.172 0 .333.032a.9.9 0 0 1 .285.11q.125.076.2.208.074.132.074.335a.67.67 0 0 1-.144.435.62.62 0 0 1-.41.213l.635 1.056h-.513l-.554-1.012h-.31v1.012h-.426zm.756 1.012q.091 0 .183-.008a.6.6 0 0 0 .167-.04.3.3 0 0 0 .123-.099.3.3 0 0 0 .047-.184.3.3 0 0 0-.044-.168.3.3 0 0 0-.115-.097.5.5 0 0 0-.157-.042 1.4 1.4 0 0 0-.167-.01h-.367v.648z"
        clipRule="evenodd"
      />
      <path
        fill="#d97b16"
        d="M12.756 10.938a1.256 1.256 0 1 0 0-2.513 1.256 1.256 0 0 0 0 2.512"
      />
    </g>
    <defs>
      <clipPath id="discover_svg__a">
        <path fill="#fff" d="M2 5.5h20V18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDiscover;
